import { render, staticRenderFns } from "./LibraryView.vue?vue&type=template&id=ddea5f36&scoped=true&"
import script from "./LibraryView.vue?vue&type=script&lang=js&"
export * from "./LibraryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddea5f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
